export default {
  workPending: 'work_pending',
  paid: 'paid',
  pending_approval: 'pending_approval',
  in_progress: 'in_progress',
  declined: 'declined',
};
